import { pxToRem } from '../utils/font';
import { gray } from './colors';

export const BASE_RADIUS = 8;

export const radii = {
  none: pxToRem(0),
  xs: pxToRem(2),
  sm: pxToRem(4),
  base: pxToRem(BASE_RADIUS),
  lg: pxToRem(12),
  xl: pxToRem(16),
  full: pxToRem(1000),
};

export const shadows = {
  none: '0 0 0 rgba(0,0,0,0)',
  xs: '0px 1px 4px rgba(0,0,0,.16)',
  sm: '0px 2px 8px rgba(0,0,0,.16)',
  md: '0px 4px 16px rgba(0,0,0,.16)',
  lg: '0px 8px 24px rgba(0,0,0,.16)',
  focus: `0 0 0 var(--focus-offset) var(--focusable-offset-color), 0 0 0 calc(var(--focus-width) + var(--focus-offset)) ${gray[600]}`,
};
